itsoftApp.createModule("customVideo", function () {
    var module = this;
    
    var initCustomVideo = function () {
        document.addEventListener('click', (e) => {
            const target = e.target;
            
            if (target.closest('.js-video__btn-play')) {
                const parent = target.closest('.js-video')
                parent.classList.add('_play');
                const video = parent.querySelector('video')
                video.play();
            }
        })
    };

    document.querySelectorAll(".js-promo-video").forEach((el) => {
        el.onplay = function(e){
            console.log("onPlay")
            document.querySelectorAll(".js-promo-video").forEach((el1) => {
                if(el === el1)
                    el1.play();
                else
                    el1.pause();
            });
        }
    });

    initCustomVideo();

    module.callback = initCustomVideo;
});